// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2YBbI","title":"FrontImage_title__3giBv"};